import { render, staticRenderFns } from "./ApiMarkerAttribute.vue?vue&type=template&id=386c8cd5&scoped=true"
import script from "./ApiMarkerAttribute.vue?vue&type=script&lang=js"
export * from "./ApiMarkerAttribute.vue?vue&type=script&lang=js"
import style0 from "./ApiMarkerAttribute.vue?vue&type=style&index=0&id=386c8cd5&prod&lang=scss"
import style1 from "./ApiMarkerAttribute.vue?vue&type=style&index=1&id=386c8cd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c8cd5",
  null
  
)

export default component.exports